import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { GenericFilter } from 'shared';
import { AvailableModulesItemCount, SubTenantDto, TenantDto, TenantGroupRoleDto, TenantGroupRoleUserDto, TenantScope, TenantToCreate, UserTenantDto } from 'shared';
import { UserDto } from 'shared';
import { AccountService } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { debounceTime, finalize, switchMap, tap } from 'rxjs';
import { GeneralUtils } from "../../modules/shared/utils/general-utils";
import { Clipboard } from '@angular/cdk/clipboard';
import { SelectUserpermissionDialogComponent } from '../../user-management/select-userpermission-dialog/select-userpermission-dialog/select-userpermission-dialog.component';
import { SelectUserpermissionsResult } from 'shared';
import { SelectData } from 'shared';
import { DatabaseMigrationService } from 'shared';
import { max } from 'lodash';
import { AddTenantModulesDialogComponent } from '../edit-tenant/add-tenant-modules-dialog/add-tenant-modules-dialog.component';


@Component({
    selector: 'tenant-dialog',
    templateUrl: './add-tenant-dialog.component.html',
    styleUrls: ['./add-tenant-dialog.component.scss'],
    standalone: false
})
export class AddTenantDialogComponent implements OnInit {

  tenantForm!:UntypedFormGroup;
  userTenant!:UserTenantDto;
  _db!:string;
  scopes:TenantScope[] = [];
  scope!:TenantScope;
  selectedScope!:TenantScope;
  selectedUserEmail!:string;
  isLoading = true;
  scopeSelected = false;
  userSelected = false;
  users:UserDto[] = [];
  user!:UserDto;
  filter!: GenericFilter;
  tenants:TenantDto[] = [];
  selectedTenant!:TenantDto;
  tenantSelected = false;
  inclTGR = true;
  forSystemTest = false;
  showInclTGRInfo = false;
  showTenantsForScope = false;
  selectUserpermissionResult: SelectUserpermissionsResult = new SelectUserpermissionsResult();
  availableModules: AvailableModulesItemCount[] = [];
  
 
  constructor(private fb: UntypedFormBuilder,
    public _dialogRef: MatDialogRef<AddTenantDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private oauthService: OAuthServiceService,
    private tenantService: TenantService,
    private accountService: AccountService,
    private clipboard: Clipboard,
    private dialog: MatDialog,
    private databaseMigrationService: DatabaseMigrationService
    ) { }

  ngOnInit(): void {

        this.createTenantForm();
        this.searchData();

  }

  createTenantForm() {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    this.tenantForm = this.fb.group({
      name:[null],
      maxUserCount:[100],
      maxProjectCount:[10],
      maxInvitationValidForDays:[3],
      responsibleUser: [null, [Validators.pattern(emailregex), Validators.required]],
      wpServerUrl: [null],
      wpTenantName: [null],
      wpApiKeyInbound: [GeneralUtils.generateGuid()],
      wpApiKey: [null],
      wpApiUser: [null],
    });
  }

  searchData() {
    this.filter = new GenericFilter();
    let searchText = "";
    this.accountService.getAllUsers(searchText, 1, 10000).subscribe({
      next: (users) => {
        this.users = users;
        console.log("------------> users: ", this.users);
        this.tenantService.getScopes(this.tenantService.currentTenantName).subscribe({
          next:(scopes) => {
              this.scopes = scopes;
            },
            //error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTCLONEDERROR"]}`)
        })   
      },
      error: (error: any) => {
        // this.isLoadingResults = false;
        // this.isRateLimitReached = true;
        this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERRETRIVALERROR"]}`)
      }
    });

    this.tenantForm.get('responsibleUser')?.valueChanges
      .pipe(debounceTime(300),
        tap(() => this.isLoading = true),
        switchMap((value: any) => this.accountService.getAllUsers(value, 1, 10000)
          .pipe(finalize(() => this.isLoading = false))))
      .subscribe({
        next: (userDto: UserDto[]) => {
          this.users = userDto;
          //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERFOUND"]} `);
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERFOUNDERROR"]}`)
      });
   
    }

  getTenantsForScope() {
    if(this.selectedScope.systemtype !== "WINPLAN") {
      //this.tenantService.getTenants(new GenericFilter()).subscribe({
      this.tenantService.getTenantsByScope(this.selectedScope.name).subscribe({
        next: (tenants) => {
        this.tenants = tenants;
        // console.log("------------> getTenantsForScope: ", this.tenants);
        if(tenants.length > 0) {
          this.showTenantsForScope = true;
        } else {
          this.showTenantsForScope = false;
          this.notificationService.info(`${this.translate.data["INFO"]}`, `${"Es sind keine Mandanten zur Auswahl von Vorlagen für den ausgewählten Scope vorhanden."}`);

        }

      },
      // error: (error: any) => {
      // this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTRETRIVALERROR"]}`)
      // }
      });
    }
  }

  selectTemplates() {
    console.log("-----> add-tenant-dialog: selectTemplates - selectedTenant = ", (this.selectedTenant) ? this.selectedTenant.name : "unbekannt");
    let selectData = new SelectData();
    selectData.action = "selectAllTemplates";
    selectData.tenantName = (this.selectedTenant) ? this.selectedTenant.name : "unbekannt";
    //selectData.userId = this.adminUserId;
    //const dialogRef = this.dialog.open(SelectUserpermissionDialogComponent, { height: '800px', width: '800px', data: null, position: { top: '100px', left: '1200px' } });
    const dialogRef = this.dialog.open(SelectUserpermissionDialogComponent, { height: '600px', width: '800px', data: selectData});

    dialogRef.afterClosed().subscribe((result: any) => { 

      console.log("-----> add-tenant-dialog: Proj-Role Id-Pairs = ", result)
      this.selectUserpermissionResult.projRolePairs = (result && result != "undefined") ? result : [];
      if (result !== undefined) {
        this.add();
        dialogRef.close();
      } else { //Abbruch
        this.selectUserpermissionResult.projRolePairs = [];
        // this.isTemplateSelection = false;
        this.userSelected = false;
        //this.copyUserName = "";
        this.tenantForm.patchValue({responsibleUser: ""});
      }
      //this.checkTemplates = false;
    },
    //error
    );
  }


  onChange() {
    this.inclTGR = !this.inclTGR;
  }

  onChangeForTest() {
    this.forSystemTest = !this.forSystemTest;
  }

  add() {

    

    let tenantName = "";
    if(this.selectedScope.systemtype === "WINPLAN") {
      let wpUrl = GeneralUtils.toComfortableUrlString(this.tenantForm.value.wpServerUrl);
      let wpTenantName = GeneralUtils.toComfortableTenantName(this.tenantForm.value.wpTenantName);
      tenantName = wpUrl + "_" + wpTenantName;
    } else {
      tenantName = this.tenantForm.value.name
    }

    this.tenantService.isTenantExisting(tenantName).subscribe({
      next: (tenantExists) => {
        if(tenantExists) {
          this.notificationService.error(`${this.translate.data["WARN"]}`, `${"Der Mandant {t} existiert bereits!".replace("{t}", tenantName)}`);
          return;
        } else {
          const dialogRef = this.dialog.open(AddTenantModulesDialogComponent, { width: '800px', data: null /*this.availableModules*/ });
            dialogRef.afterClosed().subscribe((result: any) => { 
              if (result === undefined || result === null) {
                this._dialogRef.close();
                return;
              }
              this.availableModules = result;
              const jsonData = (this.availableModules != null) ? JSON.stringify(this.availableModules) : null;
              //this.tenantForm.patchValue({additionalModules: jsonData});
              this.notificationService.wait(undefined, "Neuer Mandant wird angelegt ....");

              if(tenantName != "" && this.selectedScope != null && this.tenantForm.value.responsibleUser != null) {
                let tenant = new TenantToCreate();
                tenant.name = tenantName;
                tenant.scopeName = this.selectedScope.name;
                tenant.frontendUrl = this.selectedScope.frontendurl;
                tenant.systemType = this.selectedScope.systemtype;
                tenant.wpApiKeyInbound = this.tenantForm.value.wpApiKeyInbound;
                tenant.wpServerUrl = this.tenantForm.value.wpServerUrl;
                tenant.wpApiUser = this.tenantForm.value.wpApiUser;
                tenant.wpApiKey = this.tenantForm.value.wpApiKey;
                tenant.wpTenant = this.tenantForm.value.wpTenantName;
                tenant.maxUserCount = this.tenantForm.value.maxUserCount;
                tenant.maxProjectCount = this.tenantForm.value.maxProjectCount;
                tenant.invitationValidForDays = this.tenantForm.value.maxInvitationValidForDays;
                tenant.isForSystemTest = this.forSystemTest;
                tenant.projectRolePairs = this.selectUserpermissionResult.projRolePairs;
                tenant.additionalModules = (jsonData != null && jsonData != "[]") ? jsonData : "";
          
                console.log("------------> add-tenant-dialog: tenant = ", tenant);
                //console.log("------------> add-tenant-dialog: selected user = ", this.tenantForm.value.responsibleUser);

                this.createTenantDbAndTenantAdmin(tenant)       
                //this._dialogRef.close(tenant);
              }
            },
            //error
          );
       }
      },
      error: (error: any) => {}
    });

  }

  displayFn(user: any) {
    console.log("displayFn: user = ", user)
    if (user) { return user; }
  }

  cancel() {
    console.log("------------> add-tenant-dialog: cancel - selectedTenant = ", (this.selectedTenant) ? this.selectedTenant.name : "unbekannt");
    this._dialogRef.close();
  }

  isFormValid() {
    // console.log("------------> isFormValid: tenantForm = ", this.tenantForm.value.name); 
    // console.log("------------> isFormValid: selectedScope = ", this.selectedScope);
    // console.log("------------> isFormValid: userSelected = ", this.userSelected);
    // console.log("------------> isFormValid: tenantForm = ", this.tenantForm.valid);
    // console.log("------------> isFormValid: responsibleUser = ", this.tenantForm.value.responsibleUser);
    // console.log("------------> ----------------------------------------------------------");
    // return this.tenantForm.value.name && this.selectedScope && (this.userSelected || this.tenantForm.value.responsibleUser) && this.tenantForm.valid;
    return (this.selectedScope 
              && (this.tenantForm.value.name && this.selectedScope.systemtype !== "WINPLAN") || (this.tenantForm.value.wpServerUrl && this.tenantForm.value.wpTenantName  && this.selectedScope.systemtype === "WINPLAN"))
              && (this.tenantForm.value.wpApiKey || this.selectedScope.systemtype !== "WINPLAN")
              && (this.userSelected || this.tenantForm.value.responsibleUser);
  }

  optionUserSelected(event: any) {
    this.user = event.option.value;
    console.log("------------> selected user = ", this.user);
    this.userSelected = true;
    this.selectedUserEmail = this.user.email;

  }

  createTenantDbAndTenantAdmin(tenant:TenantToCreate) {
    tenant.projectRolePairs = this.selectUserpermissionResult.projRolePairs;
    tenant.inclTGR = this.inclTGR;
    tenant.isForSystemTest = this.forSystemTest;
    tenant.copyTenant = (this.selectedTenant) ? this.selectedTenant.name : "undefined";
    this.tenantService.createTenancy(tenant).subscribe({
      next:(tenant:TenantDto) => {
        console.log("------------> createTenantDbAndTenantAdmin: tenant = ", tenant);
        if(tenant.name == null) {
          this.notificationService.error(`${this.translate.data["ERROR"]}`, "Mandant konnte nicht angelegt werden, weil das .fdb File noch existiert und gelockt ist!");
          this.notificationService.info("", "Nach Neustart des Servers kann der Mandant angelegt werden!");
          return;
        }
        this.databaseMigrationService.executeTenantDbsQueries().subscribe({
          next: (data: any) => {
            // this.notificationService.success("", "Mandantendatenbanken erfolgreich aktualisiert")
            // this.refresh();
            this._dialogRef.close(tenant);
            this.createAdminTenantGroupRole(tenant);
            this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["TENANTADDED"]}`);
          },
          error: (error: any) => {
            // this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error updating tenant databases");
            // this.notificationService.info("", error.error.developerMessage.Message)
            console.log("------------> database-update for new tenant ", error.error.developerMessage.Message);
          }
        });
      },
      error: (error: any) => {
        this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTADDEDERROR"]}`);
        this.notificationService.info("", error.error.developerMessage.Message)
        console.log("------------> add-tenant-dialog: ", error.error.developerMessage);
   }
    })
  }

  createAdminTenantGroupRole(tenant:TenantDto) {
    let tenantGroupRole = new TenantGroupRoleDto;
    tenantGroupRole.name = "Administrator"
    tenantGroupRole.displayName = "Administrator";
    // tenantGroupRole.permissions = "TENANTADMIN,CREATE_USER,MANAGE_USERS,CREATE_PROJECT,MANAGE_PROJECTS,CREATE_APITOKEN,CREATE_OWN_APITOKEN,MANAGE_AUDIT)";
    tenantGroupRole.permissions = "TENANTADMIN";

    this.tenantService.createTenantGroupRole(tenant.name, tenantGroupRole).subscribe({
      next: (tenantGroupRole) => {
        console.log("------------> createTenantGroupRole: ", tenantGroupRole);
        this.createTenantAdminUser(tenant, tenantGroupRole);
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PLATFORMGROUPROLEADDEDERROR"]}`)
    });

  }

  createTenantAdminUser(tenant:TenantDto, tenantGroupRole:TenantGroupRoleDto) {
    let adminUser = new UserDto();
    let undefinedCopyUser = "undefined";
    adminUser.userName = this.tenantForm.value.responsibleUser.email;
    adminUser.email = this.tenantForm.value.responsibleUser.email;
    console.log("------------> createTenantAdminUser: ", adminUser);
    this.accountService.createUser(adminUser, /*isTenantAdmin:*/true, undefinedCopyUser, tenant.name, tenant.id).subscribe({
      next: (user) => {
        console.log("------------> createTenantAdminUser: ", user);
        this.assignGroupRoleToTenantAdmin(tenant, tenantGroupRole, user);
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERADDEDERROR"]}`)
    });

  }

  assignGroupRoleToTenantAdmin(tenant:TenantDto, role:TenantGroupRoleDto, user:UserDto) {
    let tenantGroupRoleUser = new TenantGroupRoleUserDto;
    tenantGroupRoleUser.roleId = role.id;
    tenantGroupRoleUser.name = role.name;
    tenantGroupRoleUser.userId = user.id;
    tenantGroupRoleUser.userName = user.userName;
    this.tenantService.createTenantGroupRoleUser(tenant.name, tenantGroupRoleUser).subscribe({
      next: (tenantGroupRoleUser) => {
        console.log("------------> createTenantGroupRoleUser: ", tenantGroupRoleUser);
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PLATFORMGROUPROLEADDEDERROR"]}`)
    });
  }

  copy(){
    let tenantName = "";
    let text = "";
    if(this.selectedScope.systemtype === "WINPLAN") {
      let wpUrl = GeneralUtils.toComfortableUrlString(this.tenantForm.value.wpServerUrl);
      let wpTenantName = GeneralUtils.toComfortableTenantName(this.tenantForm.value.wpTenantName);
      tenantName = wpUrl + "_" + wpTenantName;
      text = "Mandanten Name: " + tenantName + "\n" +
                "Admin: " + this.tenantForm.value.responsibleUser.email + "\n" +
                "WP Server Url: " + this.tenantForm.value.wpServerUrl + "\n" +
                "WP Mandant: " + this.tenantForm.value.wpTenantName + "\n" +
                "WP API Key Inbound: " + this.tenantForm.value.wpApiKeyInbound + "\n" +
                "WP API User: " + this.tenantForm.value.wpApiUser + "\n" +
                "WP API Key: " + this.tenantForm.value.wpApiKey + "\n";
    } else {
      tenantName = this.tenantForm.value.name
      text = "Mandanten Name: " + tenantName + "\n" +
                "Admin: " + this.tenantForm.value.responsibleUser.email + "\n" +
                "WP Server Url: nicht vorhanden\n" +
                "WP Mandant: nicht vorhanden\n" +
                "WP API User: nicht vorhanden\n" +
                "WP API Key: nicht vorhanden\n" +
                "WP API Key Inbound: nicht vorhanden\n";
      if (this.forSystemTest)
        text = text + "Mandant ist für Systemtest vorgesehen\n";
    }
    this.clipboard.copy(text);
    this.notificationService.info("", "Mandanten Informationen wurden in die Zwischenablage kopiert!");
  }

}
